import apiUrlConfig from 'configs/apiUrlConfig';
import AuthenticatedRequestService from 'services/requests/Authenticated';

const URLS = {
  INDEX: `${apiUrlConfig.apiEndPoint()}/dashboards/:dashboardId/dashboard_components`,
  UPDATE: `${apiUrlConfig.apiEndPoint()}/dashboards/:dashboardId`,
  SHOW: `${apiUrlConfig.apiEndPoint()}/dashboard_components/:componentId`,
};

function insertIdToUrl(url, id) {
  return url.replace(/:dashboardId|:componentId/, id);
}

class DashboardMetricsApi {
  static addNew(dashboardId, data) {
    const INDEX_URL = insertIdToUrl(URLS.INDEX, dashboardId);
    return AuthenticatedRequestService.post(INDEX_URL, data);
  }

  static getDetails(componentId) {
    const INDEX_URL = insertIdToUrl(URLS.SHOW, componentId);
    return AuthenticatedRequestService.get(INDEX_URL);
  }

  static updateComponents(componentId, data) {
    const INDEX_URL = insertIdToUrl(URLS.UPDATE, componentId);
    return AuthenticatedRequestService.patch(INDEX_URL, data);
  }

  static getAll(dashboardId) {
    const INDEX_URL = insertIdToUrl(URLS.INDEX, dashboardId);
    return AuthenticatedRequestService.get(INDEX_URL);
  }

  static saveConfig(componentId, data) {
    const INDEX_URL = insertIdToUrl(URLS.SHOW, componentId);
    return AuthenticatedRequestService.patch(INDEX_URL, data);
  }

  static deleteConfig(componentId) {
    const INDEX_URL = insertIdToUrl(URLS.SHOW, componentId);
    return AuthenticatedRequestService.delete(INDEX_URL);
  }
}

export default DashboardMetricsApi;



// WEBPACK FOOTER //
// ./src/apis/DashboardMetrices.js